import React, { useState, useEffect} from 'react';
import { useLocation,useNavigate } from 'react-router-dom';

import {useNotification} from 'config/Notification';

import { fetchAssessmentReportdetailsforReview as fetchAssessmentReportdetailsforReviewService} from 'services/modules/cap/standardservice';

import LoadingOverlay from 'components/LoadingOverlay.jsx';

import '../../styles/cap.css';

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { 
  Collapse,
  IconButton, 
  Paper,
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow,  
  TablePagination,
} from '@mui/material';

const ViewAssessmentPage = () => {

  // State variables
  const [assessmentsList,setAssessmentsList]=useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
//code change - 3 const lines
  const [assessmentStatus, setAssessmentStatus] = useState('');
  const [approvalSummary, setApprovalSummary] = useState('');
  const [approvedAt, setApprovedAt] = useState(null);

  
  // Location 
  const location = useLocation();
  const urlparams = location.state;

  // React router
  const navigate = useNavigate();

  // Notification
  const {openNotification} = useNotification();

  // Method handles to change the page
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  // Method handles to change the rows per page based on user selection
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  // Displays all the subcontrols under main control by clicking on the main control
  const handleRowClick = (rowId) => {
    setExpandedRow((prevRow) => (prevRow === rowId ? null : rowId));
  };

  useEffect(()=>{
    fetchPendingAssessments();
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  },[]);
  
  // Method fetches the assessment details to review
  const fetchPendingAssessments=async ()=> {
    setLoading(true);
    try {
      let params = {assessmentid:urlparams.assessmentid};
      const response = await fetchAssessmentReportdetailsforReviewService({params });

        if (Array.isArray(response.data)) {
          setAssessmentsList(response.data);
    
        } else {
          setAssessmentsList(response.data.controls || []);
    
          setAssessmentStatus(response.data.status || '');
          setApprovalSummary(response.data.approval_remarks || '');
          setApprovedAt(response.data.approved_at || null);
        } //code change end
    } catch (error) {
      openNotification("Error fetching pending assessments:", 'error');
    } finally{
      setLoading(false);
    }
  };
  
  return (
    <div>
      <div className="row py-1">
        <p>
          <img className="px-1 icons-style" src="../assets/icons/003-clipboard.svg" alt="View"  />
          <b className="px-1">Review assessment </b>
          <img className="px-1 icons-style" src="../assets/icons/right-layer.svg" alt="View"   />
      
          {urlparams.standard==='CIS' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cis.png"   draggable="false" alt='CIS-Icon'/>
          )}
          {urlparams.standard==='ISO-27001' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-iso-27001.png"   draggable="false" alt='ISO-Icon'/>
          )}
          {urlparams.standard==='NIST' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nist.png"   draggable="false" alt='NIST-Icon'/>
          )}
          {urlparams.standard==='COBIT' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-cobit.png"   draggable="false" alt='COBIT-Icon'/>
          )}
          {urlparams.standard==='TISAX' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-tisax.png"   draggable="false" alt='TISAX-Icon'/>
          )}
          {urlparams.standard==='NIS 2.0' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-nis2.png"   draggable="false" alt='NIS-Icon'/>
          )}
          {urlparams.standard==='Ransomware' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-ransomware.png"   draggable="false" alt='Ransomware-Icon'/>
          )}
          {urlparams.standard==='Data Protection' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-data-protection.png"   draggable="false" alt='DP-Icon'/>
          )}
          {urlparams.standard==='Supplier Risk' && (
            <img  className="px-sm standard-icon-size"  src="../assets/icons/standard-supplier-risk.png"   draggable="false" alt='SR-Icon'/>
          )}
 
          <span> { urlparams.standard }  </span> - <span>{ urlparams.assessmentid }</span> 
        </p>
      </div>

      {loading && <LoadingOverlay />}
      
      <div>
        {assessmentsList.length>0 &&(
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3}>Control name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? assessmentsList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  : assessmentsList
                  ).map((item) => (
                    <React.Fragment key={item.controlID}>
                      <TableRow >
                        <TableCell >
                          <IconButton
                            className='expand-row'
                            size="small"
                            onClick={() => handleRowClick(item.controlID)}
                          >
                            {expandedRow === item.controlID ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>{item.controlID +' : ' + item.controlName}</TableCell>
                        <TableCell>{item.assessment_id}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Collapse in={expandedRow === item.controlID} timeout="auto" unmountOnExit>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Ref</TableCell>
                                  <TableCell>Control</TableCell>
                                  <TableCell>Rating</TableCell>
                                  <TableCell>Rationale for rating</TableCell>
                                  <TableCell>Reject remarks</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {item.subcontrols.map((subcontrol) => (
                                  <TableRow key={subcontrol.subcontrolID}>
                                    <TableCell>{subcontrol.subcontrol}</TableCell>
                                    <TableCell>
                                      <div className='subcontrols'>
                                        {subcontrol.subcontrolName}
                                      </div>
                                    </TableCell>
                                    <TableCell>{subcontrol.severity}</TableCell>
                                    <TableCell>{subcontrol.rational}</TableCell>
                                    <TableCell>{subcontrol.assessment_comments}</TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                ))}
              </TableBody>
            </Table>
            
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              component="div"
              count={assessmentsList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
        {/* Code change start*/} 
          {/* APPROVAL SUMMARY BOX */}
        {assessmentsList.length > 0 &&
        (assessmentStatus === "Approved" ||
          assessmentStatus === "Mitigation In Progress" ||
          assessmentStatus === "Mitigation Initiated") && (

          <div className="row mt-4 px-3">
            <div className="col-lg-12 card shadow-sm p-3"
              style={{ border: '1px solid #e3e6f0' }}>
              
              <label className="font-weight-bold text-success">
                Approval Summary
              </label>

              <textarea
                className="form-control bg-light"
                rows="4"
                value={approvalSummary}
                readOnly
              />

              {approvedAt && (
                <small className="text-muted mt-2 d-block">
                  Approved on: {new Date(approvedAt).toLocaleString()}
                </small>
              )}
            </div>
          </div>
        )}
        {/*code change end */}

        {assessmentsList.length>0 &&(
          <div className='assessments-list'>
            <button
              className="go-back-button"
              style={{ width: '150px' }}
              onClick={()=>  navigate('/cap/user-pendingassessments')}
            >
              <ArrowLeftIcon  />
              Go back
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default ViewAssessmentPage;
